<template>
  <div>
    <div class="templateReview div-layout tab-resetStyle">
      <el-tabs v-model="activeName">
        <el-tab-pane label="待审核" name="pendingApproval">
          <pendingApproval v-if="activeName == 'pendingApproval'" />
        </el-tab-pane>
        <el-tab-pane label="已审核" name="audited" :lazy="true">
          <audited v-if="activeName == 'audited'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import pendingApproval from './pendingApproval.vue';
import audited from './audited.vue';
export default {
  name: 'UserManage',
  components: {
    pendingApproval,
    audited
  },
  data() {
    return {
      activeName: 'pendingApproval'
    };
  }
};
</script>
